/**
 * @fileoverview Action type constants for the SensaiAI module
 * @module sensaiAi/constants/actionTypes
 */

import { NAMESPACE } from './namespaces'

/**
 * @constant {Object} COACH - Coach-related action types
 */
export const COACH = {
  FETCH_REQUEST: `${NAMESPACE.COACH}/FETCH_REQUEST`,
  FETCH_SUCCESS: `${NAMESPACE.COACH}/FETCH_SUCCESS`,
  FETCH_FAILURE: `${NAMESPACE.COACH}/FETCH_FAILURE`,
  CREATE_REQUEST: `${NAMESPACE.COACH}/CREATE_REQUEST`,
  CREATE_SUCCESS: `${NAMESPACE.COACH}/CREATE_SUCCESS`,
  CREATE_FAILURE: `${NAMESPACE.COACH}/CREATE_FAILURE`,
  SET_PROCESSING_COMPLETE: `${NAMESPACE.COACH}/SET_PROCESSING_COMPLETE`,
  RESET_COACH_STATE: `${NAMESPACE.COACH}/RESET_COACH_STATE`,
}

/**
 * @constant {Object} STATUS - Status-related action types
 */
export const STATUS = {
  FETCH_REQUEST: `${NAMESPACE.STATUS}/FETCH_REQUEST`,
  FETCH_SUCCESS: `${NAMESPACE.STATUS}/FETCH_SUCCESS`,
  FETCH_FAILURE: `${NAMESPACE.STATUS}/FETCH_FAILURE`,
}

/**
 * @constant {Object} PROCESSING - Processing-related action types
 */
export const PROCESSING = {
  SET_REQUEST_ID: `${NAMESPACE.PROCESSING}/SET_REQUEST_ID`,
  SET_STATUS: `${NAMESPACE.PROCESSING}/SET_STATUS`,
  SET_COMPLETE: `${NAMESPACE.PROCESSING}/SET_COMPLETE`,
  SET_FAILURE: `${NAMESPACE.PROCESSING}/SET_FAILURE`,
}

export const CREDENTIALS = {
  SET_SENSAI_CREDENTIALS: `${NAMESPACE.ROOT}/SET_SENSAI_CREDENTIALS`,
}

/**
 * @constant {Object} GAMIFICATION - Gamification-related action types
 */
export const GAMIFICATION = {
  MEET_SENSAI_REQUEST: `${NAMESPACE.GAMIFICATION}/MEET_SENSAI_REQUEST`,
  MEET_SENSAI_SUCCESS: `${NAMESPACE.GAMIFICATION}/MEET_SENSAI_SUCCESS`,
  MEET_SENSAI_FAILURE: `${NAMESPACE.GAMIFICATION}/MEET_SENSAI_FAILURE`,
}
